<script setup>

import MainFooter from '@/components/partial/MainFooter.vue'
import {Budget} from '@/common/api.service'
import {ref} from 'vue'
import {useRouter} from 'vue-router'

const id = ref(window.localStorage.getItem('LK_ID'))
const item = ref({})
const counterparty = ref({})
const user = ref({})
const router = useRouter()
await router.isReady()

let loadItem = async () => {
  Budget.projectDraft(id.value).then(({data}) => {
    item.value = data.data
    if (!counterparty.value.id && item.value.counterparty_id) {
      Budget.counterpartyById(item.value.counterparty_id).then(async ({data}) => {
        counterparty.value = data
      }).catch(async (data) => {
        console.error(data)
        //await router.push({name: 'ErrorPage', query: {code: '404', message: 'Ошибка'}})
      })
    }
  }).catch(async (data) => {
    console.error(data)
    await router.push({name: 'ErrorPage', query: {code: '404', message: 'Ошибка'}})
  })
}

await Budget.account().then(async ({data}) => {
  user.value = data.user
  await loadItem()
}).catch(async (data) => {
  console.error(data)
  await router.push({name: 'ForbiddenPage'})
})

</script>

<template>
  <div class="wrapper">
    <MainHeader></MainHeader>
    <main class="page">
      <div class="breadcrumbs-wrapper --estimate-style">
        <ul class="breadcrumbs --estimate-style">
          <li><a href="#">Реестр проектов</a></li>
          <li><a href="#">{{item.counterparty_name}}</a></li>
          <li>Смета расходования средств по проекту</li>
        </ul>
      </div>
      <div class="content --estimate-style">
        <div class="container">
          <div class="content__wrapper">
            <div class="control-block --estimate-style">
              <div class="control-block__filters --estimate-style">
                <label for="" class="control-block__label">Версия сметы:</label>
                <select name="" id="" class="field --select --select-text-style">
                  <option value="">Черновик</option>
                </select>
              </div>
              <div class="control-block__buttons --estimate-style">
                <button class="button --cancel">удалить черновик</button>
                <button class="button --send">Отправить на согласование</button>
                <button class="button">Редактировать</button>
              </div>
            </div>
            <div class="content-row --estimate-style --responsive-wrap">
              <div class="content-row__item --big --max-width-100">
                <div class="table-container">
                  <div class="table-title">
                    <div>Средства займа, руб.</div>
                  </div>
                  <table class="table">
                    <thead>
                    <tr>
                      <th>№ статьи/подстатьи</th>
                      <th>Направление целевого использования средств</th>
                      <th>Зарплата сотрудников, вкл. налоги и взносы от ФОТ</th>
                      <th>Работы и услуги, выполняемые третьими лицами, приобретение прав</th>
                      <th>Материалы и комплектующие</th>
                      <th>Приобретение оборудования</th>
                      <th>Итого</th>
                      <th>Ограничения</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>1</td>
                      <td>Научные и иные исследования в интересах проекта, включая аналитические исследования
                        рынка
                      </td>
                      <td>0,00</td>
                      <td>0,00</td>
                      <td>0,00</td>
                      <td>0,00</td>
                      <td>0,00</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Разработка нового продукта/технологии</td>
                      <td>9 000 000,00</td>
                      <td>15 000 000,00</td>
                      <td>5 000 000,00</td>
                      <td>5 000 000,00</td>
                      <td>34 000 000,00</td>
                      <td>
                        7 млн
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>Итого</td>
                      <td>9 000 000,00</td>
                      <td>16 000 000,00</td>
                      <td>5 000 000,00</td>
                      <td>5 000 000,00</td>
                      <td>35 000 000,00</td>
                      <td></td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="content-row --estimate-style">
              <div class="content-row__item --long">
                <div class="table-container">
                  <div class="table-title">В том числе распределение по годам, руб.</div>
                  <table class="table">
                    <thead>
                    <tr>
                      <th>Год</th>
                      <th>Зарплата сотрудников, вкл. налоги и взносы от ФОТ</th>
                      <th>Работы и услуги, выполняемые третьими лицами, приобретение прав</th>
                      <th>Материалы и комплектующие</th>
                      <th>Приобретение оборудования</th>
                      <th>Итого</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>2023</td>
                      <td>0,00</td>
                      <td>0,00</td>
                      <td>0,00</td>
                      <td>0,00</td>
                      <td>0,00</td>
                    </tr>
                    <tr>
                      <td>2024 (понесенные расходы)</td>
                      <td>10 000 000,00</td>
                      <td>25 000 000,00</td>
                      <td>0,00</td>
                      <td>0,00</td>
                      <td>35 000 000,00</td>
                    </tr>
                    <tr>
                      <td>2024 (планируемые расходы)</td>
                      <td>10 000 000,00</td>
                      <td>20 000 000,00</td>
                      <td>0,00</td>
                      <td>0,00</td>
                      <td>30 000 000,00</td>
                    </tr>
                    <tr>
                      <td>Итого</td>
                      <td>10 000 000,00</td>
                      <td>25 000 000,00</td>
                      <td>0,00</td>
                      <td>0,00</td>
                      <td>35 000 000,00</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="content-row --estimate-style" v-if="user.settings && user.settings.is_view_sofinance">
              <div class="content-row__item --long --double-th">
                <div class="table-container">
                  <div class="table-title">Средства софинансирования, руб.</div>
                  <table class="table">
                    <thead>
                    <tr>
                      <th></th>
                      <th colspan="4">Расходы по Проекту, произведенные до заключения договора займа</th>
                      <th>Обязательства по софинансированию Проекта после заключения договора займа</th>
                      <th>Всего софинансирование затрат по проекту</th>
                    </tr>
                    <tr>
                      <th>Источник финансирования</th>
                      <th>2022</th>
                      <th>2023</th>
                      <th>2024</th>
                      <th>Итого</th>
                      <th></th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>Средства частных инвесторов, привлекаемые для реализации Проекта дополнительно к сумме
                        предоставленного Займа - все источники финансирования на реализацию проекта, включая собственные
                        средства компании, привлекаемые кредиты, вложения физических лиц, средства инвесторов и
                        источники финансирования, за исключением Займа Фонда и средства бюджета (субсидии и т.п.)
                      </td>
                      <td>3 000 000,00</td>
                      <td>15 000 000,00</td>
                      <td>18 000 000,00</td>
                      <td>36 000 000,00</td>
                      <td>20 000 000,00</td>
                      <td>20 000 000,00</td>
                    </tr>
                    <tr>
                      <td>В том числе средства аффилированных лиц, бенефициаров и (или) собственные средства заемщика" в
                        "В том числе средства аффилированных лиц, бенефициаров и (или) собственные средства заемщика
                        (указывается справочно)
                      </td>
                      <td>0,00</td>
                      <td>5 000 000,00</td>
                      <td>0,00</td>
                      <td>5 000 000,00</td>
                      <td>15 000 000,00</td>
                      <td>20 000 000,00</td>
                    </tr>
                    <tr>
                      <td colspan="6">Итого</td>
                      <td>76 000 000,00</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-overlay --estimate-style" id="">
        <div class="popup">
          <div class="modal-body">
            <div>Запрашиваемые Вами изменения в проект являются существенными. При изменении существенных параметров
              проекта после заключения договора займа, когда такие корректировки требуют внесения изменений в договор
              займа и связанные с ним договоры залога, поручительства, Фонд вынужден проводить повторные экспертизы и
              взимать за них плату, в соответствии с п. 15.6 договора целевого займа.
            </div>
            <div>Если Вы хотите направить новую версию сметы на рассмотрение в Фонд, заполните поле Обоснование,
              сгенерируйте официальное письмо и загрузите его с ЭЦП.
            </div>
            <label for="">Обоснование*<textarea name="" id="" placeholder="Напишите обоснование"></textarea></label>
          </div>
          <div class="modal-bottom">
            <div class="buttons-block">
              <button class="button --send">отменить</button>
              <button class="button">Сгенерировать</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-overlay --estimate-style" id="">
        <div class="popup">
          <div class="modal-body">
            <div>Запрашиваемые вами изменения в проект не требуют подписания дополнительного соглашения.</div>
            <div>Если Вы хотите направить новую версию сметы на рассмотрение в Фонд, заполните поле Обоснование,
              сгенерируйте официальное письмо и загрузите его с ЭЦП.
            </div>
            <label for="">Обоснование*<textarea name="" id="" placeholder="Напишите обоснование"></textarea></label>
          </div>
          <div class="modal-bottom">
            <div class="buttons-block">
              <button class="button --send">отменить</button>
              <button class="button">Сгенерировать</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-overlay --estimate-style" id="">
        <div class="popup">
          <div class="modal-title">Генерация официального письма с обращением</div>
          <div class="modal-body modal-body--img"><img src="img/160654.png" alt class="--docs-img"></div>
          <div class="modal-bottom">
            <div class="buttons-block buttons-block--responsive">
              <button class="button --send">Закрыть</button>
              <button class="button">Скачать</button>
              <button class="button">Загрузить с ЭЦП</button>
            </div>
          </div>
        </div>
      </div>
    </main>
    <MainFooter></MainFooter>
  </div>
</template>

<style scoped>

</style>